import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { StackLayout } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';

// The entire page body (header, caregiver list, status badges, add-caregiver
// CTA, empty state, past caregivers) is server-driven by the Masonry node
// `core$caregiver$landingPage$root`. The `@leagueplatform/caregiver` package
// registers every custom renderer these nodes use on import. This page only
// owns the layout wrapper, document title, and page-view analytics.
export const MyCaregiversPage = () => {
  usePageViewAnalytics({ screen_name: 'My Caregivers' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_MY_CAREGIVERS' }));

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="stretch"
      css={{
        marginX: 'auto',
        padding: '$none $two',
        maxWidth: CONTENT_MAX_WIDTH,
        '@mobile': {
          padding: '$none $one',
        },
      }}
    >
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_MY_CAREGIVERS} />
    </StackLayout>
  );
};
